import { createDecorator } from '../../../../platform/instantiation/common/instantiation.js';
const ILanguageStatusService = ( createDecorator('ILanguageStatusService'));
export { ILanguageStatusService };
